__turbopack_context__.v({
  "active": "styles-module-scss-module__5JHFFG__active",
  "pagination": "styles-module-scss-module__5JHFFG__pagination",
});
